import { api } from './client.js'

export interface MfaStatus {
  mfaEnabled: boolean
  mfaRequired?: boolean
  /** False for agents: MFA is mandatory and cannot be disabled by them. */
  canDisable?: boolean
}

export interface MfaSetup {
  secret: string
  otpauthUrl: string
}

export interface MfaVerify {
  mfaEnabled: boolean
}

export interface MfaBackupCodes {
  codes: string[]
}

export function getMfaStatus(): Promise<MfaStatus> {
  return api.get<MfaStatus>('/auth/mfa/status')
}

export function setupMfa(): Promise<MfaSetup> {
  return api.post<MfaSetup>('/auth/mfa/setup', {})
}

export function verifyMfaSetup(code: string): Promise<MfaVerify> {
  return api.post<MfaVerify>('/auth/mfa/verify-setup', { code })
}

export function enrollBackupCodes(): Promise<MfaBackupCodes> {
  return api.post<MfaBackupCodes>('/auth/mfa/enroll-backup-codes', {})
}

export function disableMfa(password: string): Promise<MfaStatus> {
  return api.post<MfaStatus>('/auth/mfa/disable', { password })
}

export function resetMfa(password: string): Promise<MfaStatus> {
  return api.post<MfaStatus>('/auth/mfa/reset', { password })
}

export function setupPlatformMfa(): Promise<MfaSetup> {
  return api.post<MfaSetup>('/auth/platform/mfa/setup', {})
}

export function verifyPlatformMfaSetup(code: string): Promise<MfaVerify> {
  return api.post<MfaVerify>('/auth/platform/mfa/verify-setup', { code })
}

export function enrollPlatformBackupCodes(): Promise<MfaBackupCodes> {
  return api.post<MfaBackupCodes>('/auth/platform/mfa/enroll-backup-codes', {})
}

export function getPlatformMfaStatus(): Promise<MfaStatus> {
  return api.get<MfaStatus>('/auth/platform/mfa/status')
}

export function disablePlatformMfa(password: string): Promise<MfaStatus> {
  return api.post<MfaStatus>('/auth/platform/mfa/disable', { password })
}

export function resetPlatformMfa(password: string): Promise<MfaStatus> {
  return api.post<MfaStatus>('/auth/platform/mfa/reset', { password })
}
